"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TooltipButtonHandler_1 = require("../../components/TooltipButtonHandler");
var _globals_1 = require("../_globals");
new TooltipButtonHandler_1.TooltipButtonHandler(_globals_1.root);
